import FormHotel from "./FormHotel";

export default FormHotel;
